import React, { useEffect, useMemo } from 'react';
import { Switch, Route as RouterRoute, useLocation } from 'react-router';
import { filter, find } from 'lodash';
import { useRoutes } from './api';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Dividend from './pages/Dividend';
import FundList from './pages/FundList';
import FundItem from './pages/FundItem';
import ETFLanding from './pages/ETFLanding';
import ETFList from './pages/ETFList';
import ETFItem from './pages/ETFItem';
import ETFFaq from './pages/ETFFaq';
import ETFPCF from './pages/ETFPCF';
import ETFIndexTrack from './pages/ETFIndexTrack';
import ETFEstimate from './pages/ETFEstimate';
import NavLess from './pages/NavLess';
import NotFound from './pages/NotFound';
import Loading from './pages/Loading';
import FrontB from './pages/FrontB';
import FrontC from './pages/FrontC';
import FrontD from './pages/FrontD';
import FrontE from './pages/FrontE';
import FrontF from './pages/FrontF';
import Article from './pages/Article';
import Sitemap from './pages/Sitemap';
import line from './assets/common/line.svg';

// Customized
import ArticleDiligence from './pages/ArticleDiligence';

import FrontBTrophy from './pages/FrontBTrophy';
import FrontBAdvantage from './pages/FrontBAdvantage';

import $ from 'jquery';


const Route = ({ page: Page, ...rest }) => {
	return (
		<RouterRoute
			{...rest}
			render={(props) => {
				return (
					<div className='index-page-wrap'>
						<div className='index-container'>
							<Header />
							<div className='min-page-height'>
								<Page {...props} {...rest} />
							</div>
						</div>

						<a href='https://lin.ee/WmKZEkB' target='_blank' rel='noreferrer noopener' className='fixed-line-link'>
							<img src={line} alt='LINE 加入好友' />
						</a>

						<Footer />
					</div>
				);
			}}
		/>
	);
};

const BlankRoute = ({ page: Page, ...rest }) => {
	return (
		<RouterRoute
			{...rest}
			render={(props) => {
				return (
					<div className='index-page-wrap'>
						<Page {...props} />
					</div>
				);
			}}
		/>
	);
};

const Routes = () => {
	const location = useLocation();
	const { flattenedRoutes, isLoading } = useRoutes();

	const frontBs = useMemo(() => {
		return filter(flattenedRoutes, (route) => {
			return route.views === 'FrontB' && route.depth === 1;
		});
	}, [flattenedRoutes]);

	const frontCs = useMemo(() => {
		return filter(flattenedRoutes, (route) => {
			return route.views === 'FrontC';
		});
	}, [flattenedRoutes]);

	const frontDs = useMemo(() => {
		return filter(flattenedRoutes, (route) => {
			return route.views === 'FrontD';
		});
	}, [flattenedRoutes]);

	const frontEs = useMemo(() => {
		return filter(flattenedRoutes, (route) => {
			return route.views === 'FrontE' && route.depth;
		});
	}, [flattenedRoutes]);

	const frontFs = useMemo(() => {
		return filter(flattenedRoutes, (route) => {
			return route.views === 'FrontF';
		});
	}, [flattenedRoutes]);

	useEffect(() => {
		window.scrollTo({ top: 0 });

		if (location.pathname === '/fund/onshore_sales' || location.pathname === '/fund/offshore_sales' || location.pathname === '/fund/etf_sales' || location.pathname === '/fund/etf/estimate_sales') {
			$('meta[name=viewport]').attr('content', 'width=1024');
		} else {
			$('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0');
		}
	}, [location]);

	const getRouteData = (route) => {
		return find(flattenedRoutes, (item) => {
			return item.route === route || item.url === route;
		});
	};

	if (isLoading) {
		return <BlankRoute path='*' page={Loading} />;
	}

	return (
		<Switch>
			<Route exact path='/' page={Landing} routeData={getRouteData('/')} />
			<Route exact path='/fund/onshore' page={FundList} routeData={getRouteData('/fund/onshore')} />
			<Route exact path='/fund/onshore_sales' page={FundList} routeData={getRouteData('/fund/onshore')} />
			<Route exact path='/fund/onshore/:fundID' page={FundItem} />
			<Route exact path='/fund/onshore_sales/:fundID' page={FundItem} />

			<Route exact path='/fund/offshore' page={FundList} routeData={getRouteData('/fund/offshore')} />
			<Route exact path='/fund/offshore_sales' page={FundList} routeData={getRouteData('/fund/offshore')} />
			<Route exact path='/fund/offshore/:fundID' page={FundItem} />
			<Route exact path='/fund/offshore_sales/:fundID' page={FundItem} />

			<Route exact path='/ETFlandingpage' page={ETFLanding} routeData={getRouteData('/ETFlandingpage')} />

			<Route exact path='/fund/etf' page={ETFList} routeData={getRouteData('/fund/etf')} />
			<Route exact path='/fund/etf_sales' page={ETFList} routeData={getRouteData('/fund/etf')} />
			<Route exact path='/fund/etf/faq' page={ETFFaq} routeData={getRouteData('/fund/etf/faq')} />
			<Route exact path='/fund/etf/pcf' page={ETFPCF} routeData={getRouteData('/fund/etf/pcf')} />
			<Route exact path='/fund/etf/indextrack' page={ETFIndexTrack} routeData={getRouteData('/fund/etf/indextrack')} />
			<Route exact path='/fund/etf/estimate' page={ETFEstimate} routeData={getRouteData('/fund/etf/estimate')} />
			<Route exact path='/fund/etf/estimate_sales' page={ETFEstimate} routeData={getRouteData('/fund/etf/estimate')} />
			<Route exact path='/fund/etf/:fundID' page={ETFItem} />
			<Route exact path='/fund/etf_sales/:fundID' page={ETFItem} />

			<Route exact path='/dividend' page={Dividend} routeData={getRouteData('/dividend')} />
			<Route exact path='/dividend/onshore' page={Dividend} />
			<Route exact path='/dividend/offshore' page={Dividend} />
			<Route exact path='/dividend/etf' page={Dividend} />
			<Route exact path='/sitemap' page={Sitemap} routeData={getRouteData('/dividend')} />

			<Route exact path='/navless' page={NavLess} routeData={getRouteData('/NavLess')} />

			{frontBs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={url || route} page={FrontB} key={guid} routeData={routeData} />;
			})}
			{frontCs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={url || route} page={FrontC} key={guid} routeData={routeData} />;
			})}
			{frontCs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={`${url || route}/:guid`} page={Article} key={`${guid}params`} routeData={routeData} />;
			})}
			{frontDs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={url || route} page={FrontD} key={guid} routeData={routeData} />;
			})}
			{frontDs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={`${url || route}/:guid`} page={Article} key={`${guid}params`} routeData={routeData} />;
			})}
			{frontEs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={url || route} page={FrontE} key={guid} routeData={routeData} />;
			})}
			{frontEs.map((routeData) => {
				const { guid, url, route } = routeData;
				return <Route exact path={`${url || route}/:guid`} page={Article} key={`${guid}params`} routeData={routeData} />;
			})}
			{frontFs.map((routeData) => {
				const { guid, url, route, depth } = routeData;
				if (!depth) return null;
				return <Route exact path={url || route} page={FrontF} key={guid} routeData={routeData} />;
			})}
			{frontFs.map((routeData) => {
				const { guid, url, route, depth } = routeData;
				if (!depth) return null;
				return <Route exact path={`${url || route}/:guid`} page={Article} key={`${guid}params`} routeData={routeData} />;
			})}

			{/* Customized */}
			<Route exact path='/article-diligence' page={ArticleDiligence} />

			<Route exact path='/front-b-trophy' page={FrontBTrophy} />
			<Route exact path='/front-b-advantage' page={FrontBAdvantage} />

			<BlankRoute path='*' page={NotFound} />
		</Switch>
	);
};

export default Routes;
